import {OverflowDataViewActionInterface} from 'analysis-tool/data-view/DataViewContext';
import runModal from 'ui-library/runModal';

import ViewMetadataModal, {MetadataGridCell} from './ViewMetadataModal';

export default function getViewMetadataModalOverflowAction({
  title,
  gridCells,
  additionalContent,
}: {
  title: string;
  gridCells: Array<MetadataGridCell>;
  additionalContent?: JSX.Element;
}): OverflowDataViewActionInterface {
  return {
    icon: 'info-circle',
    onClick: () => {
      runModal(ViewMetadataModal, {
        title,
        gridCells,
        additionalContent,
      });
    },
    label: 'Metadata',
  };
}
